.field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  width: 100%;
}

/* ── Label ── */
.label {
  display: inline-flex;
  align-items: flex-start;
  gap: 0.125rem;
  color: var(--text-secondary);
}
.required {
  color: var(--error-solid);
}
.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

/* ── Field box (mirrors `Input`'s `.box`/`.inputCell`) ── */
.box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  background: var(--surface);
  box-shadow: var(--shadow-xs);
  transition:
    border-color 150ms ease,
    box-shadow 150ms ease;
}
.md {
  padding: 0.625rem 0.875rem;
}
.sm {
  padding: 0.5rem 0.875rem;
}

.box:focus-within {
  border-color: var(--brand-solid);
  box-shadow: var(--focus-ring);
}
.box.error {
  border-color: var(--error-solid);
}
.box.error:focus-within {
  box-shadow: var(--focus-ring-error);
}
.box.disabled {
  background: var(--surface-secondary);
  cursor: not-allowed;
}

/* ── Trigger (the "field" itself — a button, not a native input: chosen, never typed) ── */
.trigger {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: var(--text-primary);
  font-family: var(--font-family-base);
  text-align: left;
  cursor: pointer;
}
.trigger:disabled {
  color: var(--text-disabled);
  cursor: not-allowed;
}

.icon {
  flex-shrink: 0;
  color: var(--text-quaternary);
}

.value {
  overflow: hidden;
  flex: 1 1 0;
  min-width: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--text-md-font-size);
  line-height: var(--text-md-line-height);
}
.placeholder {
  color: var(--text-quaternary);
}

.clear {
  flex-shrink: 0;
}

/* ── Hint / error message ── */
.hint {
  color: var(--text-tertiary);
}
.errorText {
  color: var(--error-solid);
}

@media (forced-colors: active) {
  .box:focus-within {
    outline: 2px solid Highlight;
    outline-offset: 2px;
  }
}
